import { Alert, Snackbar } from "@mui/material";
import { createContext, useContext, useState } from "react";


type severityType = 'error' | 'warning' |'info' | 'success';

const CouponAlertContext = createContext<{
    showAlert:(message:string,severity:severityType)=> void
}>({
    showAlert:()=>{}
});


const CouponAlertProvider=({children}:{children:React.ReactNode})=>{

    const [alert , setAlert] = useState<{
        message:string,
        open:boolean,
        severity:severityType
    }>({message:'',open:false,severity:'success'})



    const showAlert = (message:string , severity:severityType)=>{
        setAlert({
            message,
            open:true,
            severity
        })
    }

    const hideAlert = ()=>{
        setAlert({message:'',open:false,severity:'success'});
    }

    return <CouponAlertContext.Provider value={{showAlert}}>
        {children}

        <Snackbar
              ClickAwayListenerProps={{ onClickAway: () => null }}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={alert.open}
              autoHideDuration={2000}
              onClose={() => setAlert((pre) => ({ ...pre, open: false }))}
          >
              <Alert
                  onClose={() => setAlert((pre) => ({ ...pre, open: false }))}
                  severity={alert.severity}
                  sx={{ width: '100%' }}
              >
                  {alert.message}
              </Alert>
          </Snackbar>
    </CouponAlertContext.Provider>
}


const useCouponAlert = ()=>{
    const context  = useContext(CouponAlertContext);
    if(context)
        return context;
    else throw new Error('useCouponAlert must be used within an AlertProvider');
}

export {useCouponAlert,CouponAlertProvider}